import { InvoiceModel } from '@frontend/api-invoices';

/**
 * Calculate the surcharge amount based on the billed amount and basis points.
 * @param billedAmount The total amount billed ($100 = 10000).
 * @param basisPoints The basis points to calculate the surcharge (300 = 3%).
 * @returns The calculated surcharge amount.
 */
export const calculateSurchargeAmount = (invoice: InvoiceModel) => {
  if (invoice.appliedSurchargeAmount) {
    return invoice.appliedSurchargeAmount;
  }
  if (invoice.configuredSurchargeBasisPoints) {
    return invoice.billedAmount * (invoice.configuredSurchargeBasisPoints / 10000);
  }
  return 0;
};

export const calculateSurchargeTotal = (invoice: InvoiceModel) => {
  return invoice.billedAmount + calculateSurchargeAmount(invoice);
};

export const calculateAppliedOrEstimatedSurcharge = (invoice: InvoiceModel) => {
  return !!invoice.appliedSurchargeAmount ? invoice.appliedSurchargeAmount : calculateSurchargeAmount(invoice);
};
